<template>
<div>

    <el-crud :baseUrl="'/excuses'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        ref="crud">

        <template slot="table">
            <el-table-column
                prop="company_id_number"
                label="Cód.">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Descripción">
            </el-table-column>
            <el-table-column
                align="center"
                label="Justificada">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.justified" type="success" size="mini">Si</el-tag>
                    <el-tag v-else type="danger" size="mini">No</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Remunerada">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.paid" type="success" size="mini">Si</el-tag>
                    <el-tag v-else type="danger" size="mini">No</el-tag>
                </template>
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Código" label-width="120px" :prop="resource.company_id_number" :error="scope.errors.company_id_number">
                <el-input v-model="resource.company_id_number" auto-complete="off" size="mini" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="Descripción" label-width="120px" :prop="resource.description" :error="scope.errors.description">
                <el-input v-model="resource.description" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Justificada" label-width="120px" :prop="resource.justified.value" :error="scope.errors.justified">
                <el-radio-group v-model="resource.justified.value">
                    <el-radio-button label="Si" size="small"></el-radio-button>
                    <el-radio-button label="No" size="small"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Remunerada" label-width="120px" :prop="resource.paid.value" :error="scope.errors.paid">
                <el-radio-group v-model="resource.paid.value">
                    <el-radio-button label="Si" size="small"></el-radio-button>
                    <el-radio-button label="No" size="small"></el-radio-button>
                </el-radio-group>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nuevo Tipo de Permiso',
                    EditItemTitle: 'Editar Tipo de Permiso',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el tipo de permiso. Desea continuar?'
                },
                resource:{
                    company_id_number: null,
                    description: null,
                    justified: {
                        value: '',
                        setValue: (value) => {
                            this.resource.justified.value = value ? 'Si' : 'No';
                        },
                        getValue: () => {
                            return this.resource.justified.value === 'Si';
                        }
                    },
                    paid: {
                        value: '',
                        setValue: (value) => {
                            this.resource.paid.value = value ? 'Si' : 'No';
                        },
                        getValue: () => {
                            return this.resource.paid.value === 'Si';
                        }
                    }
                },
            }
        },
        components: {
            'el-crud': el_crud,
        },
        methods: {
        }
    }
</script>
